var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniEtc02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.939453,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#974444"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_13012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.939453,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#D69F5E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_13012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.11 205.619C154.175 212.852 168.875 213.963 178.21 213.964C185.99 213.523 188.833 209.798 188.572 208.182C188.096 205.251 189.128 203.422 185.08 199.026C181.033 194.63 157.451 179.612 146.012 174.666C134.573 169.721 122.068 167.593 117.327 172.285C114.037 175.542 114.679 181.16 117.327 186.193C119.38 190.1 128.11 199.447 140.11 205.619Z",
    fill: "#0F0D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.608 144.45C244.235 155.355 258.681 154.398 264.88 154.398C275.406 154.075 278.883 149.378 278.64 147.966C278.2 145.402 279.156 143.803 275.406 139.959C271.655 136.116 249.806 122.983 239.207 118.659L239.159 118.639C228.565 114.317 214.348 108.517 209.962 112.614C206.914 115.461 208.284 124.246 210.737 128.646C213.19 133.047 216.114 137.958 226.608 144.45Z",
    fill: "#0F0D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9555 136.27C89.7527 133.287 87.1816 127.127 87.1816 121.474C87.4793 113.69 89.5293 118.714 91.0836 118.714C92.6379 118.714 96.2051 125.191 97.2413 130.66C98.2775 136.129 122.907 162.656 102.836 147.799C97.614 143.934 94.126 139.21 91.9857 136.311L91.9555 136.27Z",
    fill: "#0F0D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.502 172.756L141.033 164.943L144.098 167.113C145.873 168.37 146.117 170.187 145.028 171.725C143.924 173.284 142.128 173.624 140.326 172.348L138.923 171.355L137.12 173.902L135.502 172.756ZM139.848 170.049L140.992 170.859C141.952 171.539 142.803 171.332 143.356 170.54C143.911 169.767 143.812 168.912 142.856 168.226L141.712 167.417L139.848 170.049Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 178.109C142.35 177.75 142.226 177.055 142.592 176.561C142.933 176.057 143.629 175.942 144.133 176.307C144.617 176.642 144.746 177.34 144.394 177.837C144.039 178.338 143.337 178.449 142.857 178.109Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.138 179.578L150.669 171.766L153.733 173.936C155.508 175.192 155.753 177.01 154.664 178.547C153.56 180.106 151.764 180.447 149.962 179.171L148.559 178.177L146.756 180.724L145.138 179.578ZM149.484 176.872L150.627 177.682C151.588 178.362 152.439 178.154 152.991 177.363C153.547 176.59 153.448 175.734 152.492 175.049L151.348 174.239L149.484 176.872Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.118 177.748L153.586 185.56L151.989 184.429L157.521 176.617L159.118 177.748Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.398 188.437C155.605 187.159 155.326 185.22 156.645 183.368C157.919 181.557 159.903 181.123 161.619 182.338C163.157 183.426 163.683 185.257 162.269 187.253L161.949 187.706L157.945 184.872C157.319 185.757 157.456 186.672 158.278 187.262C158.827 187.642 159.383 187.68 159.788 187.44L161.309 188.517C160.315 189.441 158.847 189.455 157.398 188.437ZM158.656 183.868L161.148 185.633C161.647 184.917 161.519 184.057 160.803 183.558C160.073 183.033 159.166 183.217 158.656 183.868Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.902 206.65C157.48 213.36 171.671 214.391 180.684 214.391C188.194 213.983 190.94 210.527 190.687 209.028C190.228 206.309 191.224 204.613 187.317 200.535C183.409 196.458 160.643 182.527 149.599 177.939C138.556 173.352 126.483 171.378 121.906 175.731C118.73 178.751 119.35 183.963 121.906 188.631C123.888 192.255 132.316 200.926 143.902 206.65Z",
    fill: "#17161E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.954 140.03C251.32 151.598 266.373 150.583 272.832 150.583C283.799 150.24 287.422 145.257 287.169 143.759C286.711 141.04 287.706 139.343 283.799 135.266C279.891 131.188 257.125 117.257 246.081 112.67L246.031 112.649C234.993 108.064 220.18 101.911 215.61 106.257C212.433 109.278 213.861 118.597 216.417 123.265C218.974 127.933 222.019 133.143 232.954 140.03Z",
    fill: "#17161E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5093 131.235C85.5277 128.474 83.2148 122.775 83.2148 117.545C83.4827 110.343 85.3267 114.991 86.7249 114.991C88.1231 114.991 91.3321 120.983 92.2643 126.044C93.1964 131.104 115.352 155.647 97.2968 141.901C92.5995 138.325 89.4618 133.955 87.5364 131.272L87.5093 131.235Z",
    fill: "#17161E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9277 116.043C83.7264 133.115 106.971 149.921 118.493 156.19L118.032 136.85C114.218 134.217 105.449 129.031 94.6429 119.405C85.9977 111.704 83.2306 97.9731 82.9277 92.0703V116.043Z",
    fill: "#315317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.526 156.218L118.049 137.32L121.659 134.699L121.856 153.124L118.526 156.218Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.104 153.134L118.785 140.047L121.104 138.15L121.281 151.163L119.104 153.134Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.104 153.128L118.785 140.041L129.699 146.143L128.162 158.196L119.104 153.128Z",
    fill: "#698B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.261 77.762C253.277 76.3012 252.988 72.9319 251.703 71.1406",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.136 77.5193C254.444 75.8803 254.701 71.9498 253.26 69.3398",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.712 208.874C197.228 209.219 195.763 209.592 193.771 208.32",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.048 207.732C198.584 207.983 197.401 208.24 196.379 207.266",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.206 188.283C208.51 188.457 206.443 188.701 203.75 188.283",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.376 186.893C208.642 187.086 206.72 187.356 204.908 186.893",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.525 198.904C197.962 199.66 199.28 201.25 201.063 201.557",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.943 198.02C198.2 198.634 199.12 199.918 200.75 200.134",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.828 127.775C156.761 126.921 150.077 131.69 147.744 134.181C154.309 155.339 163.077 199.392 164.026 205.941C165.213 214.127 190.381 215.856 197.619 209.212C203.519 204.414 209.041 195.142 209.913 182.944C210.625 172.983 204.693 155.181 195.201 144.503C185.71 133.825 174.913 128.842 164.828 127.775Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.291 132.407C146.795 133.275 146.552 135.497 145.416 136.955C156.417 161.528 176.628 210.425 180.23 211.557C184.733 212.972 194.998 206.865 198.485 195.72C201.619 187.099 200.097 175.264 197.433 167.998C192.285 153.957 181.825 142.076 171.538 136.125C161.054 130.06 151.843 132.022 150.291 132.407Z",
    fill: "#315317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.799 133.576L132.512 142.96C132.371 156.352 134.465 185.614 143.98 195.53C155.872 207.926 166.174 210.69 175.135 212.113C184.097 213.537 189.765 207.274 191.457 205.244L191.505 205.187C193.908 202.305 200.028 194.967 198.069 177.799C193.432 156.409 179.853 143.975 170.41 137.911C162.045 132.54 151.971 132.485 147.799 133.576Z",
    fill: "#1E221A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.833 146.212L118.785 140.047L121.104 138.15L132.01 144.241L129.833 146.212Z",
    fill: "#CDDFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.274 94.7677L224.27 69.7806L227.4 66.5742L227.404 91.8136L224.274 94.7677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.914 89.9175C102.114 97.593 94.7332 110.752 96.44 117.803C90.8721 112.222 88.8287 109.433 88.2903 106.829C86.5839 100.767 83.317 90.6273 91.5071 82.3294C101.745 71.9571 114.086 65.6993 132.589 61.3305C148.149 57.6564 169.269 56.2562 189.333 58.9776C205.643 61.19 220.184 66.2382 224.27 69.2463V94.5213C218.504 92.6493 212.932 89.8693 185.991 84.0777C159.05 78.2862 134.394 80.8524 116.914 89.9175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.608 140.274C125.405 141.136 124.851 158.355 125.856 167.04C127.579 176.588 132.307 183.624 137.737 190.165C155.006 210.066 170.9 206.83 174.493 204.954C178.296 202.967 187.515 194.531 184.974 180.33C183.022 169.419 173.664 157.814 169.611 153.697C165.489 149.509 154.714 139.473 140.608 140.274Z",
    fill: "#1E221A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.088 149.132C125.352 149.378 125.84 163.994 128.051 171.272C133.452 187.089 147.431 198.023 152.967 200.426C159.257 203.157 172.637 202.509 175.799 193.407C178.962 184.304 174.99 175.567 174.242 173.92C173.858 173.078 160.758 148.824 141.088 149.132Z",
    fill: "#315317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.862 79.0228L224.814 72.8578L227.133 70.9609L238.039 77.0514L235.862 79.0228Z",
    fill: "#CDDFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.133 90.3407L224.814 72.8574L235.728 78.9593L234.191 95.4091L225.133 90.3407Z",
    fill: "#698B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.687 134.695L118.046 137.314C97.7012 126.882 88.3438 114.52 85.0759 105.747C78.9878 89.4088 87.6161 81.2574 92.6895 76.5372C98.5336 70.6353 115.374 59.1694 138.928 56.1139C151.372 54.4997 161.285 53.5435 175.833 54.3925C204.573 56.5391 222.165 63.3933 227.383 66.5734L224.23 69.8048C220.891 67.8967 208.825 63.966 202.96 62.641C194.273 60.8365 172.687 57.5484 155.847 58.8315C134.796 60.4353 125.65 62.9428 121.64 64.5466C117.63 66.1505 106.748 69.4921 97.8602 77.1105C89.8938 83.9388 87.7829 87.953 87.1635 92.0134C85.2171 112.223 110.084 129.062 121.687 134.695Z",
    fill: "#CDDFC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.159 108.912C214.97 106.935 216.726 100.799 217.628 97.9785L220.333 103.034L232.797 122.2C241.262 127.295 258.288 137.556 258.665 137.838C259.041 138.121 280.613 136.859 291.353 136.192C296.33 132.586 305.862 126.551 304.169 131.254C302.053 137.133 293.116 151.008 267.131 149.949C241.145 148.891 227.129 134.449 221.598 126.986C216.416 119.993 215.394 111.382 215.159 108.912Z",
    fill: "#315317"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.223,
    cy: 106.648,
    rx: 48.7072,
    ry: 36.4962,
    transform: "rotate(22.8984 263.223 106.648)",
    fill: "#1E221A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.113 129.455C232.316 128.119 233.11 125.132 234.663 123.871",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.137,
    cy: 100.573,
    rx: 22.8571,
    ry: 13.8908,
    transform: "rotate(22.8984 264.137 100.573)",
    fill: "#27321B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.405,
    cy: 103.721,
    rx: 19.537,
    ry: 11.8731,
    transform: "rotate(22.8984 266.405 103.721)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.332 120.209C275.711 127.55 293.416 124.939 297.877 114.377C302.338 103.815 291.866 89.3029 274.487 81.9623C257.108 74.6217 239.403 77.2328 234.942 87.7944C230.481 98.3561 240.953 112.869 258.332 120.209ZM261.791 112.024C271.73 116.222 281.856 114.729 284.408 108.688C286.959 102.648 280.97 94.3475 271.03 90.1491C261.091 85.9507 250.964 87.4441 248.413 93.4847C245.862 99.5253 251.851 107.826 261.791 112.024Z",
    fill: "#315317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.539 102.731C217.052 100.739 218.863 96.4079 222 95.0273",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.482 107.362C217.725 105.581 218.708 101.777 220.699 100.807",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.598 128.243C231.023 126.058 232.759 121.02 236.302 118.35",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.162 126.884C229.275 124.807 230.334 120.265 233.668 118.717",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.29 120.311C258.326 121.73 258.032 125.055 256.564 126.998",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.84 136.947C186.23 137.033 184.915 137.478 184.537 138.568",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.845 136.141C184.9 136.466 182.816 137.455 182.039 138.814",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.037 157.219C202.319 157.439 200.467 158.128 198.809 159.124",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.843 158.287C203.291 158.472 201.95 159.022 201.01 159.741",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.18 131.871C160.104 131.163 160.352 129.557 161.944 128.797",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.088 132.14C161.134 131.612 161.452 130.447 162.356 130.014",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.707 137.884C174.918 137.25 175.603 135.938 176.652 135.758",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.859 153.177C190.372 152.499 191.732 151.088 193.071 150.871",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.219 153.724C190.701 153.241 191.866 152.221 192.662 152.004",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.889 167.683L144.551 161.529L146.863 164.032C148.273 165.559 148.096 167.232 146.822 168.418C145.543 169.591 143.858 169.621 142.438 168.085L141.248 166.797L138.994 168.879L137.889 167.683ZM142.233 165.887L143.27 167.01C144.107 167.907 144.987 167.845 145.691 167.194C146.404 166.536 146.523 165.676 145.69 164.774L144.653 163.652L142.233 165.887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.518 173.925C143.153 173.529 143.173 172.905 143.573 172.544C143.955 172.183 144.575 172.216 144.945 172.608C145.293 172.994 145.277 173.613 144.891 173.97C144.495 174.336 143.871 174.307 143.518 173.925Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.343 175.752L152.005 169.599L154.316 172.102C155.727 173.629 155.55 175.302 154.275 176.488C152.997 177.66 151.311 177.691 149.892 176.154L148.702 174.866L146.448 176.949L145.343 175.752ZM149.687 173.957L150.724 175.079C151.561 175.977 152.441 175.914 153.145 175.264C153.858 174.605 153.976 173.746 153.144 172.844L152.107 171.721L149.687 173.957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.413 176.537L151.751 182.69L150.663 181.512L157.325 175.359L158.413 176.537Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.735 186.124C153.346 184.619 153.495 182.768 155.059 181.323C156.605 179.895 158.52 179.865 159.838 181.291C160.968 182.515 161.177 184.283 159.425 185.902L159.056 186.242L155.835 182.755C155.001 183.559 154.958 184.528 155.664 185.283C156.135 185.803 156.675 185.944 157.114 185.819L158.177 186.969C157.116 187.557 155.806 187.283 154.735 186.124ZM156.64 182.02L158.82 184.38C159.497 183.746 159.569 182.827 158.944 182.151C158.294 181.447 157.313 181.475 156.64 182.02Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.607 242.711V222.914H190.373C194.871 222.914 197.455 225.689 197.455 229.586C197.455 233.537 194.83 236.258 190.264 236.258H186.709V242.711H182.607ZM186.709 232.949H189.607C192.041 232.949 193.23 231.582 193.217 229.586C193.23 227.617 192.041 226.291 189.607 226.277H186.709V232.949ZM201.42 242.957C200.135 242.957 199.096 241.932 199.123 240.66C199.096 239.402 200.135 238.377 201.42 238.391C202.637 238.377 203.689 239.402 203.689 240.66C203.689 241.932 202.637 242.957 201.42 242.957ZM207.025 242.711V222.914H214.791C219.289 222.914 221.873 225.689 221.873 229.586C221.873 233.537 219.248 236.258 214.682 236.258H211.127V242.711H207.025ZM211.127 232.949H214.025C216.459 232.949 217.648 231.582 217.635 229.586C217.648 227.617 216.459 226.291 214.025 226.277H211.127V232.949ZM228.436 222.914V242.711H224.389V222.914H228.436ZM238.307 243.012C233.754 242.998 230.965 240.059 230.979 235.355C230.965 230.775 233.795 227.672 238.143 227.672C242.039 227.672 245.115 230.133 245.115 235.191V236.34H234.971C234.971 238.582 236.297 239.963 238.389 239.977C239.77 239.963 240.754 239.361 241.15 238.473H245.006C244.432 241.221 241.971 242.998 238.307 243.012ZM234.971 233.797H241.287C241.273 231.992 240.029 230.693 238.225 230.707C236.365 230.693 235.053 232.088 234.971 233.797Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniEtc02);
export default __webpack_public_path__ + "static/media/mini_etc_02.3bd9eb345cba1bc18374bb9d354f156e.svg";
export { ForwardRef as ReactComponent };